import { basket_channel } from "javascript/channels/basket_channel";
import fav from 'javascript/src/product/fav';
document.addEventListener('turbolinks:load',()=>{ fav.load(basket_channel); })
